let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("40PSN")).then(() => parcelRequire('fdrDa'));